import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_DOMAIN_URI, config, llm_train_uri } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class SummarizeService {

  baseUrl = `${config.PROTOCOL}://${config.HOST}:${config.PORT}/canstring/${config.VERSION}`;

  llm_model2_url = `${llm_train_uri.model2_url}`;

  constructor(private http: HttpClient) { }



  private getModel2Headers() {
    return {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem('llm_token')
      })
    }
  }

  getSummarize(payLoad: any) {
    // let payload = {
    //   "text":extractText,
    //   "task":"summarization"
    //   };
    // return this.http.post("https://document.canstringai.com:8443/ca-llm/multiple_task",payload);

    return this.http.post(this.llm_model2_url + "/generalgpt/query", payLoad, this.getModel2Headers());
  }

  uploadSummaryPdf(payload: any) {
    return this.http.post(BASE_DOMAIN_URI + "/pdf/upload-pdf", payload);
  }

  createHistory(payLoad: any) {
    return this.http.post(`${this.baseUrl}/createHistory`, payLoad);
  }

  getChatBotHistory() {
    let user_id = window.localStorage.getItem('user_id');
    return this.http.get(`${this.baseUrl}/getChatBotHistory?user_id=${user_id}`);
  }


}
